<template>
  <div>
    <div class="noticeone-head">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="系统通知" name="first">
          <xttz></xttz>
        </el-tab-pane>
        <el-tab-pane label="评论回复" name="second">
          <plhf></plhf>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="comment-foot">
      <div class="block">
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
        </el-pagination>-->
      </div>
    </div>
  </div>
</template>

<script>
import xttz from "./xttz.vue";
import plhf from "./plhf.vue";

export default {
  components: {
    xttz,
    plhf
  },
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>
<style>
.el-pagination {
  margin-top: 20px;
}
.el-tabs__item {
  font-size: 18px;
  color: #808080;
}

.el-tabs__item.is-active {
  color: #000;
  font-weight: bold;
}

.el-tabs__item:hover {
  color: #000;
}

.el-tabs__active-bar {
  background-color: #28a3b1;
}
</style>
<style scoped="scoped">
.comment-foot {
  width: 900px;
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
}

.noticeone-head {
  width: 900px;
  height: auto;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  padding: 30px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/noticeone.vue